<router-outlet></router-outlet>
@if (loading$ | async) {
  <div class="progress-spinner-overlay">
    <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
  </div>
}
